// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1chTq","calendarButtons":"ClockData_calendarButtons__1ghnv"};